// Swipe a banner sideways to dismiss it (a phone). Spread the result onto the banner: <div {...swipeDismiss(close)}>. A tap is handled by the banner's own onClick.
export function swipeDismiss(onDismiss, distance = 50) {
  let startX = null;
  let startY = null;
  return {
    onTouchStart: (e) => { const t = e.touches && e.touches[0]; if (t) { startX = t.clientX; startY = t.clientY; } },
    onTouchEnd: (e) => {
      const t = e.changedTouches && e.changedTouches[0];
      if (t && startX != null && Math.abs(t.clientX - startX) >= distance && Math.abs(t.clientX - startX) > Math.abs(t.clientY - startY)) onDismiss();
      startX = null; startY = null;
    },
  };
}
